import { __extends } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [0, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AutoCompleteComponent } from '@apto/autocomplete';
import { ListingModel, PropertyModel } from '@apto/models';
import { AuthService, LogsService } from '@apto/ionic-lib/services';
import { CompaniesService, ContactsService, PropertiesService, ImagesService, TypesService, ListingsService, FeaturesService, PropertiesServiceSpaceAutocomplete } from '@apto/services';
import { BasePipelineEditForm } from '../base-pipeline-edit-form/base-pipeline-edit-form';
import { DECIMAL_REGEX, INTEGER_REGEX, PERCENT_INT_REGEX, PERCENT_REGEX, validationMessages } from '@apto/shared';
var EditListingForm = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(EditListingForm, _super);
    function EditListingForm(companiesService, contactsService, propertiesService, spaceAutocompleteService, featuresService, authService, logsService, formBuilder, imagesService, typesService, listingsService) {
        var _this = _super.call(this, companiesService, contactsService, propertiesService, featuresService, authService, logsService) || this;
        _this.companiesService = companiesService;
        _this.contactsService = contactsService;
        _this.propertiesService = propertiesService;
        _this.spaceAutocompleteService = spaceAutocompleteService;
        _this.featuresService = featuresService;
        _this.authService = authService;
        _this.logsService = logsService;
        _this.formBuilder = formBuilder;
        _this.imagesService = imagesService;
        _this.typesService = typesService;
        _this.listingsService = listingsService;
        _this.ListingModel = ListingModel;
        _this.PropertyModel = PropertyModel;
        _this.isSaving = false;
        _this.picklistOptions = {};
        _this.photos = [];
        _this.types = [];
        _this.dealType = '';
        _this.validationMessages = validationMessages;
        _this.datepickerOptions = {
            alignSelectorRight: true,
            openSelectorTopOfInput: true,
            showSelectorArrow: false
        };
        return _this;
    }
    EditListingForm.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.pipelineObject) {
            this.pipelineObject = new ListingModel();
        }
        else {
            this.setDealType(this.pipelineObject.type);
        }
        if (this.pipelineObject.propertyId) {
            this.photos = [];
            this.imagesService.byObjectId(this.pipelineObject.propertyId)
                .then(function (blobs) {
                _this.photos = blobs;
            });
        }
        this.setupForm();
        this.getPicklistOptions();
        this.getTypes();
    };
    EditListingForm.prototype.propertySelected = function (property) {
        this.spaceAutocompleteService.parentPropertyId = property._id;
        this.spaceAutoComplete.clearValue();
        this.setSpaceAutocompleteState();
    };
    EditListingForm.prototype.propertyChanged = function (ky) {
        if (ky === '' || !this.propertyAutoComplete.getValue()) {
            this.spaceAutocompleteService.parentPropertyId = null;
            this.spaceAutoComplete.clearValue();
        }
        this.setSpaceAutocompleteState();
    };
    EditListingForm.prototype.setSpaceAutocompleteState = function () {
        if (!this.spaceAutocompleteService.parentPropertyId) {
            this.spaceAutoComplete.setDisabledState(true);
        }
        else {
            this.spaceAutoComplete.setDisabledState(false);
        }
    };
    EditListingForm.prototype.save = function () {
        var _this = this;
        if (this.listingForm.valid) {
            Object.assign(this.pipelineObject, this.listingForm.value);
            this.saveRelationship(this.companyAutoComplete, 'clientCompany', 'seller');
            this.saveRelationship(this.contactAutoComplete, 'clientContact', 'ownerContact');
            this.saveRelationship(this.propertyAutoComplete, 'tempProperty', 'tempPropertyId');
            // set tempProperty back to property
            this.pipelineObject.property = this.pipelineObject.tempProperty;
            this.pipelineObject.propertyId = this.pipelineObject.tempPropertyId;
            if (this.spacesEnabled) {
                this.saveRelationship(this.spaceAutoComplete, 'spaceProperty', 'spacePropertyId');
                if (this.pipelineObject.spacePropertyId && this.pipelineObject.spaceProperty) {
                    this.pipelineObject.spaceParentPropertyId = this.pipelineObject.propertyId;
                    this.pipelineObject.property = this.pipelineObject.spaceProperty;
                    this.pipelineObject.propertyId = this.pipelineObject.spacePropertyId;
                }
            }
            return { listing: this.pipelineObject };
        }
        else {
            Object.keys(this.listingForm.controls).forEach(function (fieldKey) {
                _this.listingForm.controls[fieldKey].markAsDirty();
            });
        }
    };
    EditListingForm.prototype.chooseDealType = function (option) {
        this.setDealType(option);
        if (!this.isLandlordRep && !this.isTenantRep && this.spacesEnabled) {
            this.spaceAutoComplete.clearValue();
        }
    };
    EditListingForm.prototype.setDealType = function (type) {
        this.dealType = type;
        this.pipelineObject.type = type;
    };
    Object.defineProperty(EditListingForm.prototype, "isSellerRep", {
        get: function () {
            return this.pipelineObject.isSellerRep;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditListingForm.prototype, "isBuyerRep", {
        get: function () {
            return this.pipelineObject.isBuyerRep;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditListingForm.prototype, "isLandlordRep", {
        get: function () {
            return this.pipelineObject.isLandlordRep;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditListingForm.prototype, "isTenantRep", {
        get: function () {
            return this.pipelineObject.isTenantRep;
        },
        enumerable: true,
        configurable: true
    });
    // called from base class ngOnDestroy
    EditListingForm.prototype.onDestroy = function () {
        this.spaceAutocompleteService.parentPropertyId = null;
    };
    EditListingForm.prototype.setupForm = function () {
        var _this = this;
        this.pipelineObject.tempProperty = this.pipelineObject.property;
        this.pipelineObject.tempPropertyId = this.pipelineObject.propertyId;
        this.setCompany(this.companyAutoComplete, 'clientCompany', 'seller');
        this.setContact(this.contactAutoComplete, 'clientContact', 'ownerContact');
        if (this.spacesEnabled) {
            this.setupFormForSpace();
        }
        else {
            this.setProperty(this.propertyAutoComplete, 'tempProperty', 'tempPropertyId');
        }
        var listingName = this.pipelineObject && this.pipelineObject.name || '';
        var validateWithPattern = function (keyField, reg) {
            return [_this.pipelineObject[keyField], Validators.pattern(reg)];
        };
        this.listingForm = this.formBuilder.group({
            askingPriceActual: validateWithPattern('askingPriceActual', INTEGER_REGEX),
            capRate: validateWithPattern('capRate', PERCENT_REGEX),
            commissionAmount: validateWithPattern('commissionAmount', DECIMAL_REGEX),
            dateOffMarket: this.pipelineObject.dateOffMarket,
            dateOnMarket: this.pipelineObject.dateOnMarket,
            expirationDate: this.pipelineObject.expirationDate,
            market: this.pipelineObject.market,
            maxLeaseRate: validateWithPattern('maxLeaseRate', INTEGER_REGEX),
            maxPrice: validateWithPattern('maxPrice', INTEGER_REGEX),
            maxSqft: validateWithPattern('maxSqft', DECIMAL_REGEX),
            minCapRate: validateWithPattern('minCapRate', PERCENT_REGEX),
            minCashOnCash: validateWithPattern('minCashOnCash', PERCENT_REGEX),
            minIRR: validateWithPattern('minIRR', PERCENT_REGEX),
            minLeaseRate: validateWithPattern('minLeaseRate', INTEGER_REGEX),
            minLIRR: validateWithPattern('minLIRR', PERCENT_REGEX),
            minPrice: validateWithPattern('minPrice', INTEGER_REGEX),
            minSqft: validateWithPattern('minSqft', DECIMAL_REGEX),
            name: [listingName, Validators.compose([Validators.required, Validators.maxLength(80)])],
            needDate: this.pipelineObject.needDate,
            noi: validateWithPattern('noi', INTEGER_REGEX),
            probability: validateWithPattern('probability', PERCENT_INT_REGEX),
            repAgreementDate: this.pipelineObject.repAgreementDate,
            spaceSubType: this.pipelineObject.spaceSubType,
            spaceType: this.pipelineObject.spaceType,
            subMarket: this.pipelineObject.subMarket,
            totalReturn: validateWithPattern('totalReturn', PERCENT_REGEX),
            type: [this.pipelineObject && this.pipelineObject.type, Validators.required],
            yield: validateWithPattern('yield', PERCENT_REGEX),
        });
    };
    EditListingForm.prototype.setupFormForSpace = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.pipelineObject.tempPropertyId && !this.pipelineObject.tempProperty))
                            return [3 /*break*/, 2];
                        _a = this.pipelineObject;
                        return [4 /*yield*/, this.propertiesService.byId(this.pipelineObject.tempPropertyId)];
                    case 1:
                        _a.tempProperty = _b.sent();
                        _b.label = 2;
                    case 2:
                        // if we have a property and it is a space set the space stuff
                        if (this.pipelineObject.tempProperty && this.pipelineObject.tempProperty.parentPropertyId) {
                            // set the space from the property because it is actually a space
                            this.pipelineObject.spacePropertyId = this.pipelineObject.tempProperty._id;
                            this.pipelineObject.spaceProperty = this.pipelineObject.tempProperty;
                            this.pipelineObject.spaceParentPropertyId = this.pipelineObject.tempProperty.parentPropertyId;
                            // reset the tempProperty to be the parent property
                            this.pipelineObject.tempPropertyId = this.pipelineObject.spaceParentPropertyId;
                            this.pipelineObject.tempProperty = null;
                        }
                        // set autocomplete scope
                        this.spaceAutocompleteService.parentPropertyId = this.pipelineObject.tempPropertyId;
                        this.pipelineObject.spaceParentPropertyId = this.pipelineObject.tempPropertyId;
                        this.setSpace(this.spaceAutoComplete, 'spaceProperty', 'spacePropertyId');
                        this.setProperty(this.propertyAutoComplete, 'tempProperty', 'tempPropertyId');
                        this.setSpaceAutocompleteState();
                        return [2 /*return*/];
                }
            });
        });
    };
    EditListingForm.prototype.getPicklistOptions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.listingsService.getPicklistOptions(['spaceType', 'spaceSubType', 'market', 'subMarket'])];
                    case 1:
                        _a.picklistOptions = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EditListingForm.prototype.getTypes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var types;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.typesService.fetch()];
                    case 1:
                        types = _a.sent();
                        this.types = Object.keys(types.listingTypes);
                        return [2 /*return*/];
                }
            });
        });
    };
    return EditListingForm;
}(BasePipelineEditForm));
export { EditListingForm };
